import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState, useEffect } from 'react';
import { string, number, func, oneOf } from 'prop-types';
import { Copy, CheckThin, LocalActivity } from '@magalu/stereo-ui-icons';
import Flex from '../../atoms/Flex';
import { copyToClipboard } from '../../utils';
import { CouponCodeContainer, CouponCodeLabel, CouponCodeInputWrapper, CouponCodeInput, CouponCodeButton, CouponCodeCopied, CouponCodeAuxiliaryText } from './coupon-code-copy.styles';

const returnCouponLabel = ({
  type,
  value
}) => {
  if (!type || !value) return '';
  return type === 'percentage' ? `${value}% OFF` : `R$ ${value} OFF`;
};

function CouponCodeCopy(_ref) {
  let {
    auxiliaryText,
    code,
    discountType,
    discountValue,
    delay = 3000,
    expirationDate,
    onCopySuccess
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["auxiliaryText", "code", "discountType", "discountValue", "delay", "expirationDate", "onCopySuccess"]);

  const inputProps = Object.assign({}, props);
  const [isActive, setIsActive] = useState(false);
  useEffect(() => {
    let timeoutId;

    if (isActive) {
      timeoutId = setTimeout(() => setIsActive(false), delay);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [isActive, delay]);

  const handleCouponCodeCopy = async value => {
    const success = await copyToClipboard(value);

    if (success) {
      setIsActive(true);
      onCopySuccess(value);
    }
  };

  const couponLabel = returnCouponLabel({
    type: discountType,
    value: discountValue
  });
  return /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "column",
    "data-testid": "coupon-code-copy"
  }, /*#__PURE__*/React.createElement(CouponCodeContainer, null, /*#__PURE__*/React.createElement(CouponCodeLabel, null, /*#__PURE__*/React.createElement(LocalActivity, {
    width: 16,
    height: 16
  }), " ", /*#__PURE__*/React.createElement("strong", null, couponLabel)), /*#__PURE__*/React.createElement(CouponCodeInputWrapper, null, /*#__PURE__*/React.createElement(CouponCodeInput, _extends({
    "data-testid": "coupon-code-input",
    readOnly: true,
    value: code
  }, inputProps)), /*#__PURE__*/React.createElement(CouponCodeCopied, {
    "data-testid": "coupon-code-copied",
    isActive: isActive
  }, /*#__PURE__*/React.createElement(CheckThin, {
    width: 17,
    height: 13
  }), " ", /*#__PURE__*/React.createElement("span", null, "Copiado")), /*#__PURE__*/React.createElement(CouponCodeButton, {
    "data-testid": "coupon-code-button",
    startIcon: /*#__PURE__*/React.createElement(Copy, {
      width: 12,
      height: 14
    }),
    onClick: () => handleCouponCodeCopy(code)
  }, "Copiar"))), /*#__PURE__*/React.createElement(CouponCodeAuxiliaryText, null, auxiliaryText, " ", expirationDate));
}

CouponCodeCopy.defaultProps = {
  auxiliaryText: 'Copie o cupom e aplique na sacola. Válido até',
  code: '',
  discountType: '',
  discountValue: '',
  expirationDate: '',
  onCopySuccess: () => {}
};
process.env.NODE_ENV !== "production" ? CouponCodeCopy.propTypes = {
  auxiliaryText: string,
  code: string,
  discountType: oneOf(['percentage', 'absolute']),
  discountValue: string,
  delay: number,
  expirationDate: string,
  onCopySuccess: func
} : void 0;
CouponCodeCopy.displayName = 'CouponCodeCopy';
export default CouponCodeCopy;